import React from 'react';
import NumberFormat from 'react-number-format';
import AnyField from "./AnyField";

function NumberFormatFloat(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.floatValue,
                    },
                });
            }}
            thousandSeparator=" "
            allowNegative={false}
            decimalSeparator=","
            isNumericString
        />
    );
}

export default
class FloatPositiveField extends React.PureComponent {
    static propTypes = {
        ...AnyField.propTypes,
    }

    render () {
        const { InputProps, ...otherProps } = this.props;

        return <AnyField
            {...otherProps}
            InputProps={{
                ...InputProps,
                inputComponent: NumberFormatFloat,
            }}
        />;
    }
}